import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { fetchDarkWebResult, fetchDarkWebAction, fetchDarkWebGraph } from "../../actions/darkweb";
import "../../assets/css/recommendation-modal.css";
import BasicLineColumn from "../common/apexChart/lineChart";
import Pagination from "../Pagination/Pagination";
import TrialComponent from "../common/trialComponent";
import NoData from "../common/noDataComponetnt";
import ScanMessage from "../common/scanningMessage";
import moment from "moment";
import AccessPage from "../Shared/accessPage";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { API_URL } from "../../utils/constant";
import axios from "axios";
import Fancybox from "../../utils/Fancybox";
import $, { data } from "jquery";
import { rescanSingle } from "../../actions/users";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format, isValid } from "date-fns";
import ImageModal from "../common/ImageModal";
import "../../assets/css/details-slider.css";

const datePickerStyles = `
  
`;

const DarkWeb = () => {
  const { orgId } = useParams();
  const id = useSelector(state => {
    if (orgId) {
      return orgId;
    } else {
      return state?.summary?.localClient?._id || state?.summary?.clients?.[0]?._id;
    }
  });
  const userPermission = useSelector(state => {
    return state?.auth?.user?.modulePermissionsConfig?.de?.e;
  });
  const client = useSelector(
    (state) => state?.summary?.localClient || state?.summary?.clients?.[0]
  );
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [PageSize, setPerPage] = useState(10);
  const state = useSelector((state) => state?.darkweb?.response);
  const oldDnsDetails = useSelector(
    (state) => state?.darkweb?.darkWebGraph?.data
  );
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const totalPaginationCount = useSelector(
    (state) => state?.darkweb?.response?.totalCount
  );
  const auth = useSelector((state) => state?.auth?.user);
  const scanCompleted = useSelector((state) => state?.pastebin?.scanCompleted);
  const [category, setCategory] = useState("all");
  const [isModal, setModal] = useState("");
  const [forValue, setForValue] = useState("forever");
  const [lookalikeAppId, setLookalikeAppId] = useState([]);
  const [actionNote, setActionNote] = useState("");
  const [action, setAction] = useState("");
  const [totalItem, setTotalItem] = useState("");
  const [selectedValue, setSelectedValue] = useState("pleaseSelect");
  const [limit, setLimit] = useState(10);
  const [keyword, setKeyword] = useState('all');
  const [selectedIds, setSelectedIds] = useState([]);
  const [multiCheckTrue, setMultiCheckTrue] = useState(false);
  const [isUrlWarningModal, setIsUrlWarningModal] = useState(false);
  const [selectedUrl, setSelectedUrl] = useState("");
  const [isRecommendationModal, setIsRecommendationModal] = useState(false);
  const [activeRecommendationTab, setActiveRecommendationTab] = useState('guide');
  const [detailsModal, setDetailsModal] = useState(false);
  const [selectedRowDetails, setSelectedRowDetails] = useState(null);
  const [screenshotError, setScreenshotError] = useState(false);
  const [screenshotUrl, setScreenshotUrl] = useState(null);
  const [imageModalOpen, setImageModalOpen] = useState(false);
  const [imageModalSrc, setImageModalSrc] = useState("");

  // Extract keywords from client data
  const clientKeywords = client?.keyWord || [];

  const vendorName = sessionStorage.getItem('vendorName');
  const vendorId = sessionStorage.getItem('vendorId');

  const [datePickerOpen, setDatePickerOpen] = useState(false);
  const [tempStartDate, setTempStartDate] = useState(null);
  const [tempEndDate, setTempEndDate] = useState(null);
  const [startDateObj, setStartDateObj] = useState(null);
  const [endDateObj, setEndDateObj] = useState(null);

  useEffect(() => {
    if (startDate) {
      setStartDateObj(new Date(startDate));
    }
    if (endDate) {
      setEndDateObj(new Date(endDate));
    }
  }, [startDate, endDate]);

  useEffect(() => {
    if (startDate) {
      setTempStartDate(new Date(startDate));
    }
    if (endDate) {
      setTempEndDate(new Date(endDate));
    }
  }, [startDate, endDate]);

  const formatDateRange = () => {
    if (startDate && endDate) {
      return `Selected date: ${startDate ? format(new Date(startDate), 'MM/dd/yyyy') : ''} to ${endDate ? format(new Date(endDate), 'MM/dd/yyyy') : ''}`;
    } else if (startDate) {
      return `From: ${startDate ? format(new Date(startDate), 'MM/dd/yyyy') : ''}`;
    } else if (endDate) {
      return `Till: ${endDate ? format(new Date(endDate), 'MM/dd/yyyy') : ''}`;
    }
    return "Select date range";
  };

  const applyDateRange = () => {
    if (tempStartDate) {
      setStartDate(format(tempStartDate, 'yyyy-MM-dd'));
    } else {
      setStartDate('');
    }

    if (tempEndDate) {
      setEndDate(format(tempEndDate, 'yyyy-MM-dd'));
    } else {
      setEndDate('');
    }

    setDatePickerOpen(false);
    setPage(1);
  };

  const cancelDateSelection = () => {
    setTempStartDate(null);
    setTempEndDate(null);
    setStartDate('');
    setEndDate('');
    setStartDateObj(null);
    setEndDateObj(null);
    setDatePickerOpen(false);
  };

  const multicheck = (data) => {
    const allIds = data?.map((item) => item._id);
    if (selectedIds.length > 0 || selectedIds.length == 0) {
      setMultiCheckTrue(true);
      setSelectedIds(allIds);
    }
    if (multiCheckTrue == true) {
      setSelectedIds([]);
      setMultiCheckTrue(false);
    }
  };

  const singleClick = (id, data) => {
    setSelectedIds((prevSelectedIds) => {
      if (prevSelectedIds.includes(id)) {
        return prevSelectedIds.filter((selectedId) => selectedId !== id);
      } else {
        return [...prevSelectedIds, id];
      }
    });
    if (selectedIds.length > 10) {
      setMultiCheckTrue(true);
    } else {
      setMultiCheckTrue(false);
    }
  };

  const snooze = (_id, event) => {
    if (event === "markAsRemidiated") {
      $.confirm({
        title: "Are you sure?",
        content: "Do you really want to mark this as remediated?",
        type: "green", // Customize as needed
        buttons: {
          ok: {
            text: "Yes, Mark as Remediated",
            btnClass: "btn-success",
            keys: ["enter"],
            action: function () {
              let ids = [];
              ids.push(_id);
              const data = {
                action: "markAsRemediated",
                darkWebForumIds: selectedIds.length === 0 ? ids : selectedIds,
                actionNote: "",
                for: "forever",
              };
              fetchDarkWebAction(id, dispatch, page, data, category, keyword, limit);
              setSelectedValue("pleaseSelect");
              setActionNote("");
              setSelectedIds([]);
            },
          },
          cancel: function () {
            // User canceled, do nothing
          },
        },
      });
    }

  };

  const Unsnoozed = (_id) => {
    let ids = [];
    ids.push(_id);
    const data = {
      action: "resetAction",
      darkWebForumIds: selectedIds == 0 ? ids : selectedIds,
    };
    fetchDarkWebAction(id, dispatch, page, data, category, keyword, limit);
    setSelectedIds([]);
  };

  const submit = () => {
    const data = {
      action: action,
      darkWebForumIds: selectedIds == 0 ? lookalikeAppId : selectedIds,
      actionNote: actionNote,
      for: forValue,
    };
    fetchDarkWebAction(id, dispatch, page, data, category, keyword, limit);
    setModal("");
    setSelectedValue("pleaseSelect");
    setActionNote("");
    setSelectedIds([]);
  };

  const addModal = () => {
    setModal("Form Wizard modal");
  };

  let ipArray = [];
  for (
    let details = 0;
    details < oldDnsDetails?.scanDetails?.length;
    details++
  ) {
    ipArray.push(oldDnsDetails?.scanDetails[details]?.length);
  }

  let totalIp = 0,
    plainPasswords = 0;
  if (oldDnsDetails?.scanDetails) {
    totalIp = oldDnsDetails?.ipLength || 0;
    plainPasswords = oldDnsDetails?.plainPassword || 0;
  }

  useEffect(() => {
    fetchDarkWebResult(id, dispatch, page, category, startDate, endDate, limit, search, keyword);
  }, [id, dispatch, page, category, startDate, endDate, limit, search, keyword]);

  useEffect(() => {
    fetchDarkWebGraph(id, dispatch)
  }, [id])

  useEffect(() => {
    setTotalItem(totalPaginationCount);
  }, [totalPaginationCount]);

  let response = state?.data;

  let mapData = response;

  let currentTableData = [];
  if (mapData && mapData.length > 0) {
    currentTableData = mapData;
  }

  let clientName = "";

  if (JSON.parse(localStorage.getItem("OrgName"))) {
    if (sessionStorage.getItem('vendorId')) {
      clientName = sessionStorage.getItem('vendorName')
    } else {
      clientName = JSON.parse(localStorage.getItem("OrgName"));
    }
  }

  const downloadFile = async () => {
    try {
      const session = localStorage.getItem("session");
      axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
      const response = await axios.get(`${API_URL}/darkwebForum/${id}/excel`, {
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${clientName?.replace(/\s+/g, '-')}Dark Web.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      // console.error removed
    }
  };

  const reScan = () => {
    let data = {
      "moduleName": ["darkweb"]
    }
    rescanSingle(id, data)
  }

  const handleUrlClick = (e, url) => {
    e.preventDefault();
    setSelectedUrl(url);
    setIsUrlWarningModal(true);
  };

  const handleUrlConfirm = () => {
    if (selectedUrl) {
      window.open(selectedUrl, '_blank');
    }
    setIsUrlWarningModal(false);
    setSelectedUrl("");
  };

  const viewDetailsSlider = (row) => {
    setSelectedRowDetails(row);
    setDetailsModal(true);
  };

  // Manage body scroll when details modal is open
  useEffect(() => {
    if (detailsModal) {
      document.body.classList.add('details-slider-open');
    } else {
      document.body.classList.remove('details-slider-open');
    }
    // Cleanup on unmount
    return () => {
      document.body.classList.remove('details-slider-open');
    };
  }, [detailsModal]);

  // Reset screenshot state when selectedRowDetails changes
  useEffect(() => {
    if (selectedRowDetails?.fixed_screenshot_path || selectedRowDetails?.fullpage_screenshot_url) {
      setScreenshotError(false);
      setScreenshotUrl(selectedRowDetails.fullpage_screenshot_url || selectedRowDetails.fixed_screenshot_path);
    } else {
      setScreenshotError(false);
      setScreenshotUrl(null);
    }
  }, [selectedRowDetails]);


  return (
    <div className="container-fluid">
      <style>{datePickerStyles}</style>
      <AccessPage></AccessPage>
      <div className="block-header">
        <div className="row clearfix">
          <div className="col-md-6 col-sm-12">
            <h1 className="welcome-text">Dark Web Monitoring </h1>
            <nav aria-label="breadcrumb" className="mt-1">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  {vendorId ? <>
                    <Link to="/vendor"
                      onClick={(() => {
                        sessionStorage.clear();
                      })}
                    >Vendor Assessment</Link>
                  </> : <Link to="/" className="welcome-textSmall">Home</Link>}
                </li>
                {
                  vendorName ?
                    <li
                      className="breadcrumb-item active"
                      aria-current="page"
                      style={{ color: "white" }}
                    >
                      <Link to={`/dashboard/vendor/${vendorId}`}
                      >{vendorName}</Link>
                    </li> : ''
                }
                <li
                  className="breadcrumb-item active"
                  aria-current="page"
                  style={{ color: "white" }}
                >
                  Dark Web Monitoring
                </li>
              </ol>
              <br />
            </nav>
          </div>
          <div className="col-md-6 col-sm-12 hidden-xs d-flex justify-content-end align-items-center">
            <span>
              {auth?.accessLevel == "Admin" && (
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    reScan();
                  }}
                  style={{ color: "black", fontWeight: "bold" }}
                  className="btn btn-primary mr-1"
                >
                  Rescan
                </a>
              )}
            </span>            <span className="mr-2">
              <a
                onClick={(e) => {
                  e.preventDefault();
                  setIsRecommendationModal(true);
                }}
                href="#"
                className="btn btn-sm btn-primary mr-1"
                style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}
              >
                <i className="fa fa-lightbulb-o" style={{ fontSize: "14px" }}></i>
                Recommendation
              </a>
            </span>
            <span>
              {client?.subscriptionType != "trial" && mapData?.length !== 0 && (
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    downloadFile();
                  }}
                  href="/add-report"
                  className="btn btn-sm btn-primary mr-1 download-report"
                >
                  Download Details
                </a>
              )}
            </span>
          </div>
        </div>
      </div>

      {typeof scanCompleted !== "undefined" && !scanCompleted && (
        <div className="card border-success">
          <ScanMessage />
        </div>
      )}

      <div className="row clearfix">
        <div className="col-lg-4 col-md-12">
          <div className="card RecordFoundCard">
            <div className="body" style={{ minHeight: "460px" }}>
              <div className="row text-center">
                <div className="col-12 pb-4 pt-4">
                  <label className="mb-0">Records Found</label>
                  <h4 className="font-30 font-weight-bold text-col-blue">
                    {state?.totalCount || 0}
                  </h4>
                </div>
              </div>

              {client?.subscriptionType == "trial" && (
                <div className="card border-warning">
                  <TrialComponent />
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="col-lg-8 col-md-12 col-sm-12">
          <div className="card">
            <div className="body" style={{ minHeight: "460px" }}>
              <h6 className="welcome-textSmall">Previous scan details</h6>
              {oldDnsDetails && (
                <BasicLineColumn
                  dates={oldDnsDetails?.dates}
                  ipArray={oldDnsDetails?.scanDetails}
                  color={["#08283f"]}
                  yAxis="Records Found"
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <ul className="nav nav-tabs mb-2" id="myTabs" role="tablist">
        <li className="nav-item">
          <a
            className={`nav-table-tab nav-link ${category === "all" ? "active" : ""
              }`}
            onClick={() => {
              setCategory("all");
              setPage(1);
              setSelectedIds([]);
              setSearch("");
              setKeyword("all");
            }}
          >
            Current
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link nav-table-tab ${category === "risk-accepted" ? "active" : ""
              }`}
            onClick={() => {
              setCategory("risk-accepted");
              setPage(1);
              setSearch("");
              setSelectedIds([]);
              setKeyword("all");
            }}
          >
            Risk Accepted
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link nav-table-tab ${category === "false-positive" ? "active" : ""
              }`}
            onClick={() => {
              setCategory("false-positive");
              setPage(1);
              setSearch("");
              setSelectedIds([]);
              setKeyword("all");
            }}
          >
            False Positive
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link nav-table-tab ${category === "remidiated" ? "active" : ""
              }`}
            onClick={() => {
              setCategory("remidiated");
              setPage(1);
              setSearch("");
              setSelectedIds([]);
              setKeyword("all");
            }}
          >
            Remediated
          </a>
        </li>
      </ul>
      <div className="card card_tableBox">
        <div className="body">
          <div className="row">
            <div className="col-sm-3 mb-2">
              <div className="searchBoxInput p-0">
                <input
                  class="form-control form-control-sm ml-0 my-1"
                  type="text"
                  placeholder="Search"
                  aria-label="Search"
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target.value);
                    setPage(1);
                  }}
                />
              </div>
            </div>
            <div className="col-sm-3 mb-2">
              <div className="date-picker-container">
                <div className="date-range-input">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    placeholder="Select date range"
                    value={formatDateRange()}
                    onClick={() => setDatePickerOpen(true)}
                    readOnly
                  />
                  <span className="calendar-icon">
                    <i className="fa fa-calendar" aria-hidden="true"></i>
                  </span>
                </div>
              </div>
            </div>
            <div className="col-sm-2 mb-2">
              <select
                className="form-control form-control-sm"
                value={keyword}
                onChange={(e) => {
                  setKeyword(e.target.value);
                  setPage(1);
                }}
              >
                <option value="all">All Keywords</option>
                {clientKeywords.map((kw, index) => (
                  <option key={index} value={kw}>
                    {kw}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-sm-4 mb-2">
              {selectedIds?.length > 1 && userPermission && category === "all" && (
                <Box sx={{ width: 160 }}>
                  <FormControl fullWidth>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={selectedValue}
                      onChange={(event) => {
                        setAction(event.target.value);
                        snooze("", event.target.value);
                      }}
                    >
                      <MenuItem value="pleaseSelect">Snooze Options</MenuItem>
                      <MenuItem
                        value="riskAccepted"
                        onClick={() => {
                          addModal();
                        }}
                      >
                        Risk Accepted
                      </MenuItem>
                      <MenuItem
                        value="markAsFalsePositive"
                        onClick={() => {
                          addModal();
                        }}
                      >
                        False Positive
                      </MenuItem>
                      <MenuItem value="markAsRemidiated">Remediated</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
              )}
              {selectedIds.length > 1 && userPermission &&
                (category == "false-positive" ||
                  category == "risk-accepted") && (
                  <button
                    className="btn btn-primary btn-sm mr-1 Unsnooze mb-2"
                    onClick={() => Unsnoozed("")}
                  >
                    Unsnooze
                  </button>
                )}
            </div>
          </div>
          <div className="table-responsive">
            <table className="table table-custom spacing5 mb-0" style={{ tableLayout: "auto", width: "100%" }}>
              <thead>
                <tr>
                  {auth?.accessLevel != "Threat Analyst" && (category === "all" ||
                    category === "risk-accepted" ||
                    category === "false-positive") && (
                      <th>
                        <input
                          type="checkbox"
                          checked={
                            selectedIds == 0 ? false : multiCheckTrue
                          }
                          onClick={() => {
                            multicheck(currentTableData);
                          }}
                          className="checkUncheck"
                        />
                      </th>
                    )}
                  <th style={{ 
                    whiteSpace: "normal", 
                    wordBreak: "break-word",
                    maxWidth: "200px",
                    minWidth: "150px"
                  }}>Title</th>
                  <th style={{ 
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                    maxWidth: "250px",
                    minWidth: "200px"
                  }}>Thread Link</th>
                  <th>Date</th>
                  <th>Source</th>
                  <th>View Details</th>
                  {category !== "all" && <th>Action Note</th>}
                  {auth?.accessLevel != "Threat Analyst" && userPermission && (category === "all" ||
                    category === "risk-accepted" ||
                    category === "false-positive") && (
                      <th>Action</th>
                    )}
                </tr>
              </thead>
              <tbody>
                {client?.subscriptionType == "trial" ? (
                  <tr>
                    <td colSpan={6}>
                      {/* <NoData /> */}
                      <NoData />
                    </td>
                  </tr>
                ) : (
                  currentTableData?.map((row, index) => {
                    return (
                      <tr key={index}>
                        {auth?.accessLevel != "Threat Analyst" && (category === "all" ||
                          category === "risk-accepted" ||
                          category === "false-positive") && (
                            <td>
                              <input
                                onClick={() => singleClick(row?._id)}
                                checked={selectedIds?.includes(row?._id)}
                                type="checkbox"
                                className="checkUncheck"
                              />
                            </td>
                          )}
                        <td style={{ 
                          whiteSpace: "normal",
                          wordBreak: "break-word",
                          overflowWrap: "break-word",
                          maxWidth: "200px",
                          minWidth: "150px",
                          verticalAlign: "top",
                          padding: "8px",
                          lineHeight: "1.5"
                        }}>
                          <div style={{ 
                            wordBreak: "break-word",
                            overflowWrap: "break-word"
                          }}>
                            {row?.title || "N/A"}
                          </div>
                        </td>
                        <td style={{ 
                          whiteSpace: "normal",
                          wordBreak: "break-all",
                          overflowWrap: "break-word",
                          maxWidth: "250px",
                          minWidth: "200px",
                          verticalAlign: "top",
                          padding: "8px",
                          lineHeight: "1.5"
                        }}>
                          {row?.thread_link ? (
                            <a
                              href={row.thread_link}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ 
                                color: "#17a2b8",
                                textDecoration: "none",
                                wordBreak: "break-all",
                                overflowWrap: "break-word",
                                display: "inline-block",
                                maxWidth: "100%",
                                cursor: "pointer"
                              }}
                            >
                              {row.thread_link}
                            </a>
                          ) : "N/A"}
                        </td>
                        
                        <td style={{ whiteSpace: "unset" }}>
                          {moment(
                            row?.date,
                            "DD-MM-YYYY hh:mm A"
                          ).format("DD-MM-YYYY") || "N/A"}
                        </td>
                        <td>{row?.source || "N/A"}</td>
                        <td>
                          <button
                            className="btn btn-sm"
                            onClick={() => viewDetailsSlider(row)}
                            style={{
                              backgroundColor: "#17a2b8",
                              borderColor: "#17a2b8",
                              color: "#fff",
                              borderRadius: "4px",
                              padding: "4px 12px",
                              transition: "all 0.3s ease",
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "6px"
                            }}
                            onMouseEnter={(e) => {
                              e.target.style.backgroundColor = "#138496";
                              e.target.style.borderColor = "#117a8b";
                              e.target.style.transform = "translateY(-1px)";
                              e.target.style.boxShadow = "0 2px 4px rgba(0,0,0,0.2)";
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.backgroundColor = "#17a2b8";
                              e.target.style.borderColor = "#17a2b8";
                              e.target.style.transform = "translateY(0)";
                              e.target.style.boxShadow = "none";
                            }}
                          >
                            <i className="fa fa-info-circle" style={{ fontSize: "14px" }}></i>
                            <span>View Details</span>
                          </button>
                        </td>
                        {category !== "all" && <td style={{ whiteSpace: "unset" }}>{row?.actionNote ? row.actionNote : "N/A"}</td>}
                        {auth?.accessLevel != "Threat Analyst" && userPermission && category === "all" && (
                          <td>
                            <Box sx={{ width: 160 }}>
                              <FormControl fullWidth>
                                <Select
                                  labelId="demo-simple-select-label"
                                  id="demo-simple-select"
                                  value={selectedValue}
                                  onChange={(event) => {
                                    setAction(event.target.value);
                                    snooze(row?._id, event.target.value);
                                  }}
                                >
                                  <MenuItem value="pleaseSelect">
                                    Snooze Options
                                  </MenuItem>
                                  <MenuItem
                                    value="riskAccepted"
                                    onClick={() => {
                                      addModal();
                                      setLookalikeAppId([row._id]);
                                    }}
                                  >
                                    Risk Accepted
                                  </MenuItem>
                                  <MenuItem
                                    value="markAsFalsePositive"
                                    onClick={() => {
                                      addModal();
                                      setLookalikeAppId([row._id]);
                                    }}
                                  >
                                    False Positive
                                  </MenuItem>
                                  <MenuItem value="markAsRemidiated">
                                    Remediated
                                  </MenuItem>
                                </Select>
                              </FormControl>
                            </Box>
                          </td>
                        )}
                        {auth?.accessLevel != "Threat Analyst" && userPermission && (category === "risk-accepted" ||
                          category === "false-positive") && (
                            <td>
                              <button
                                className="btn btn-primary btn-sm mr-1 Unsnooze mb-2"
                                onClick={() => Unsnoozed(row?._id)}
                              >
                                Unsnooze
                              </button>
                            </td>
                          )}
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
          <div className="d-flex justify-content-between align-content-center">
            <div className="dataTables_paginate">
              {totalItem > 0 && (
                <Pagination
                  className="pagination-bar"
                  currentPage={page}
                  totalCount={totalItem}
                  pageSize={limit}
                  onPageChange={(page) => setPage(page)}
                />
              )}
            </div>
            {totalItem > 10 && (
              <select
                value={limit}
                onChange={(e) => {
                  setLimit(e.target.value)
                }}
                className="form-control limitSelectBox"
              >
                <option value={10}>10 per page</option>
                <option value={25}>25 per page</option>
                <option value={50}>50 per page</option>
                <option value={100}>100 per page</option>
              </select>
            )}
          </div>
        </div>
      </div>
      <div
        className={`modal fade Form-Wizard-modal ${isModal === "Form Wizard modal" ? "d-block show" : ""
          }`}
      >
        <div className="modal-dialog modal-lg" id="clientModal">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                {action == "markAsFalsePositive"
                  ? "Mark As False Positive"
                  : "Risk Accepted"}
              </h5>
              <button
                type="button"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  setModal("");
                  setActionNote("");
                }}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body pricing_page modal_mob">
              <div className="col-xl-12 col-lg-12 col-md-12">
                <div className="card">
                  <div className="row clearfix">
                    <div className="col-md-12">
                      <label className="col-lg-6 col-md-12">Snooze for</label>
                      <div className="form-group ol-lg-12 col-md-12">
                        <select
                          className="custom-select custom-select-sm form-control form-control-sm"
                          onChange={(e) => setForValue(e.target.value)}
                        >
                          <option value="forever">Forever</option>
                          <option value="3 months">3 Months</option>
                          <option value="6 months">6 Months</option>
                          <option value="12 months">12 Months</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <label className="col-lg-12 col-md-12">Detail</label>
                      <div className="form-group col-lg-12 col-md-12">
                        <textarea
                          onChange={(e) => setActionNote(e.target.value)}
                          value={actionNote}
                          className="form-control"
                          rows="3"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div
                      className="col-lg-12 col-md-12"
                      style={{ marginRight: "28px" }}
                    >
                      <button
                        type="button"
                        style={{ color: "black", fontWeight: "bold" }}
                        onClick={submit}
                        className="btn btn-round btn-primary mr-1 pull-right"
                      >
                        Submit
                      </button>
                      &nbsp;&nbsp;
                      <button
                        type="button"
                        onClick={() => {
                          setModal("");
                          setActionNote("");
                        }}
                        className="btn btn-round btn-default pull-right"
                        style={{ marginRight: "10px" }}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* URL Warning Modal */}
      {isUrlWarningModal && (
        <div className={`modal fade Form-Wizard-modal ${isUrlWarningModal ? "d-block show" : ""}`}>
          <div className="modal-dialog" id="urlWarningModal">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">External Link Warning</h5>
                <button
                  type="button"
                  className="close"
                  onClick={() => setIsUrlWarningModal(false)}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="alert alert-warning mb-3">
                  <i className="fa fa-exclamation-triangle mr-2"></i>
                  You are about to leave this site and visit an external URL. This link may lead to a third-party website. Please proceed with caution.
                </div>
                <p className="mb-0" style={{maxWidth:"500px",wordWrap:"break-word"}}>URL: <strong>{selectedUrl}</strong></p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-default"
                  onClick={() => setIsUrlWarningModal(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleUrlConfirm}
                >
                  Proceed Anyway
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {datePickerOpen && (
        <div className="date-range-overlay" onClick={() => setDatePickerOpen(false)}>
          <div className="date-range-picker-popup" onClick={(e) => e.stopPropagation()}>
            <div className="date-range-picker-header">
              {tempStartDate && tempEndDate
                ? `Selected date: ${format(tempStartDate, 'MM/dd/yyyy')} to ${format(tempEndDate, 'MM/dd/yyyy')}`
                : "Select date range"}
            </div>
            <div className="date-range-calendars">
              <div>
                <h6>From</h6>
                <DatePicker
                  selected={tempStartDate}
                  onChange={(date) => {
                    setTempStartDate(date);
                    if (tempEndDate && date > tempEndDate) {
                      setTempEndDate(null);
                    }
                  }}
                  selectsStart
                  startDate={tempStartDate}
                  endDate={tempEndDate}
                  inline
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                />
              </div>
              <div>
                <h6>To</h6>
                <DatePicker
                  selected={tempEndDate}
                  onChange={(date) => setTempEndDate(date)}
                  selectsEnd
                  startDate={tempStartDate}
                  endDate={tempEndDate}
                  minDate={tempStartDate}
                  inline
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                />
              </div>
            </div>
            <div className="date-range-actions">
              <button
                className="date-range-apply"
                onClick={applyDateRange}
              >
                Apply Filter
              </button>
              <button
                className="date-range-cancel"
                onClick={cancelDateSelection}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Recommendation Modal */}
      {isRecommendationModal && (
        <div className="recommendation-modal-overlay" onClick={() => setIsRecommendationModal(false)}>
          <div className="recommendation-modal-container" onClick={(e) => e.stopPropagation()}>
            <button className="recommendation-modal-close" onClick={() => setIsRecommendationModal(false)}>
              &times;
            </button>
            
            <div className="recommendation-modal-content">
              <div className="recommendation-tabs">
                <button
                  className={`recommendation-tab ${activeRecommendationTab === 'guide' ? 'active' : ''}`}
                  onClick={() => setActiveRecommendationTab('guide')}
                >
                  Guidance
                </button>
                <button
                  className={`recommendation-tab ${activeRecommendationTab === 'checklist' ? 'active' : ''}`}
                  onClick={() => setActiveRecommendationTab('checklist')}
                >
                  Action Checklist
                </button>
              </div>

              {/* GUIDANCE TAB */}
              <div className={`recommendation-tab-content ${activeRecommendationTab === 'guide' ? 'active' : ''}`}>
                <div className="guide-intro">
                  BrandSek continuously monitors dark web forums, underground marketplaces, and hidden platforms where threat actors trade stolen data, credentials, and corporate intelligence.
                </div>

                <details className="checklist-details" open>
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Monitoring Coverage & Sources</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Dark web marketplaces and criminal forums</li>
                      <li>Paste sites and data dump repositories</li>
                      <li>Telegram channels and underground chat groups</li>
                      <li>Ransomware leak sites and extortion platforms</li>
                      <li>Credential trading and stealer log exchanges</li>
                    </ul>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>How Threat Actors Use These Platforms</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Selling stolen credentials, PII, and corporate data</li>
                      <li>Advertising access to compromised networks</li>
                      <li>Coordinating ransomware and extortion campaigns</li>
                      <li>Discussing vulnerabilities and exploitation tactics</li>
                      <li>Publishing leaked documents and intellectual property</li>
                    </ul>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Types of Intelligence Detected</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Employee or customer credential exposure</li>
                      <li>Corporate documents and trade secrets</li>
                      <li>Network access or VPN credentials for sale</li>
                      <li>Mentions of planned attacks or targeting</li>
                      <li>Ransomware negotiations and data exfiltration evidence</li>
                    </ul>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Why Early Detection Matters</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <p>
                      Dark web exposure often signals active compromise or imminent attack. Early detection enables proactive credential resets, access revocations, and incident response before adversaries exploit the intelligence further.
                    </p>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Business Legal & Regulatory Impact</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <p>
                      Data appearing on dark web platforms can indicate breach incidents requiring regulatory notification under DPDPA, GDPR, or RBI cybersecurity guidelines. Proactive dark web monitoring supports compliance with ISO 27001 (A.16.1.4) incident management and CERT-In breach reporting obligations.
                    </p>
                  </div>
                </details>
              </div>

              {/* CHECKLIST TAB */}
              <div className={`recommendation-tab-content ${activeRecommendationTab === 'checklist' ? 'active' : ''}`}>
                <details className="checklist-details" open>
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Threat Validation & Classification</h3>
                      <span className="severity-badge high">High</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Verify authenticity of exposed data or mentions</li>
                      <li>Classify threat type (credential leak, data dump, targeted threat)</li>
                      <li>Assess recency and scope of exposure</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.16.1.4 · Threat Intelligence</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Immediate Risk Containment</h3>
                      <span className="severity-badge high">High</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Force password reset for exposed accounts</li>
                      <li>Revoke compromised sessions or access tokens</li>
                      <li>Block suspected compromised accounts or IPs</li>
                      <li>Notify affected users or customers if PII is exposed</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.16.1.5 · DPDPA Breach Notification</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Incident Readiness & Investigation</h3>
                      <span className="severity-badge medium">Medium</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Launch incident investigation to determine breach source</li>
                      <li>Review access logs for anomalous activity</li>
                      <li>Preserve evidence for forensic or legal action</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.16.1.7 · CERT-In Guidelines</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Stakeholder Alignment & Escalation</h3>
                      <span className="severity-badge medium">Medium</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Notify CISO, Legal, and senior management</li>
                      <li>Coordinate breach disclosure if data is confirmed exposed</li>
                      <li>Engage law enforcement or CERT-In if criminal activity is suspected</li>
                    </ul>
                    <div className="compliance-tag">RBI Cybersecurity · DPDPA</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Continuous Intelligence & Tracking</h3>
                      <span className="severity-badge low">Low</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Monitor for repeat exposure or additional data dumps</li>
                      <li>Track threat actor profiles and TTPs</li>
                      <li>Integrate findings into threat intelligence program</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.6.8 · Threat Intelligence</div>
                  </div>
                </details>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Recommendation Modal */}
      {isRecommendationModal && (
        <div className="recommendation-modal-overlay" onClick={() => setIsRecommendationModal(false)}>
          <div className="recommendation-modal-container" onClick={(e) => e.stopPropagation()}>
            <button className="recommendation-modal-close" onClick={() => setIsRecommendationModal(false)}>
              &times;
            </button>
            
            <div className="recommendation-modal-content">
              <div className="recommendation-tabs">
                <button
                  className={`recommendation-tab ${activeRecommendationTab === 'guide' ? 'active' : ''}`}
                  onClick={() => setActiveRecommendationTab('guide')}
                >
                  Guidance
                </button>
                <button
                  className={`recommendation-tab ${activeRecommendationTab === 'checklist' ? 'active' : ''}`}
                  onClick={() => setActiveRecommendationTab('checklist')}
                >
                  Action Checklist
                </button>
              </div>

              {/* GUIDANCE TAB */}
              <div className={`recommendation-tab-content ${activeRecommendationTab === 'guide' ? 'active' : ''}`}>
                <div className="guide-intro">
                  BrandSek continuously monitors underground ecosystems including dark web forums,
                  ransomware group leak sites, illicit marketplaces, and encrypted communication
                  platforms such as Telegram and Discord. Monitoring is driven by customer-defined
                  keywords and identifiers to detect early signs of compromise, exposure, or targeting.
                </div>

                <details className="checklist-details" open>
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Monitoring Coverage & Sources</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Dark web forums and invite-only hacker communities</li>
                      <li>Ransomware group leak portals and negotiation blogs</li>
                      <li>Credential and access marketplaces</li>
                      <li>Telegram channels, groups, and private broadcasts</li>
                      <li>Discord servers used for coordination and data sharing</li>
                      <li>Underground chat platforms and breach dump channels</li>
                    </ul>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>How Threat Actors Use These Platforms</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <p>
                      Modern cybercrime operates as an ecosystem. Initial access brokers advertise
                      stolen credentials, ransomware gangs publish victim previews, and fraud groups
                      coordinate attacks using encrypted chat platforms. Mentions on these channels
                      often precede real-world incidents.
                    </p>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Types of Intelligence Detected</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Sale or validation of stolen credentials or databases</li>
                      <li>Discussion of vulnerabilities or misconfigurations</li>
                      <li>Claims of network access or lateral movement</li>
                      <li>Ransomware victim announcements or countdowns</li>
                      <li>Phishing kits, impersonation campaigns, and brand abuse</li>
                    </ul>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Why Early Detection Matters</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <p>
                      Intelligence surfaced on dark web and chat platforms often appears days or weeks
                      before an attack becomes visible through traditional security controls. Early
                      detection enables proactive containment, credential rotation, and incident
                      preparedness before damage escalates.
                    </p>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Business, Legal & Regulatory Impact</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <p>
                      Confirmed underground mentions increase the likelihood of fraud, ransomware,
                      extortion, and reputational damage. Regulators and auditors increasingly expect
                      organizations to demonstrate active threat intelligence and early-warning
                      capabilities as part of cyber resilience programs.
                    </p>
                  </div>
                </details>
              </div>

              {/* CHECKLIST TAB */}
              <div className={`recommendation-tab-content ${activeRecommendationTab === 'checklist' ? 'active' : ''}`}>
                <details className="checklist-details" open>
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Threat Validation & Classification</h3>
                      <span className="severity-badge high">High</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Validate authenticity and relevance of the mention</li>
                      <li>Identify exposed data type or access claim</li>
                      <li>Assess credibility of actor or group</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.5.7 · Threat Intelligence</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Immediate Risk Containment</h3>
                      <span className="severity-badge high">High</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Rotate or revoke referenced credentials</li>
                      <li>Restrict or disable exposed access paths</li>
                      <li>Increase monitoring on affected assets</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.5.17 · RBI CSF</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Incident Readiness & Investigation</h3>
                      <span className="severity-badge medium">Medium</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Correlate intelligence with SIEM and logs</li>
                      <li>Check for signs of exploitation or access</li>
                      <li>Evaluate ransomware or extortion risk</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.5.25 · CERT-In</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Stakeholder Alignment & Escalation</h3>
                      <span className="severity-badge medium">Medium</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Notify security, legal, and leadership teams</li>
                      <li>Prepare response and communication plans</li>
                      <li>Align actions with regulatory obligations</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.5.26 · RBI Governance</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Continuous Intelligence & Tracking</h3>
                      <span className="severity-badge low">Low</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Maintain keyword-driven monitoring</li>
                      <li>Track recurrence or escalation of mentions</li>
                      <li>Document findings and remediation</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.5.24 · Risk Management</div>
                  </div>
                </details>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* Dark Web Details Slider */}
      <div
        className={`details-slider-overlay ${detailsModal ? "show" : ""}`}
        onClick={() => {
          setDetailsModal(false);
          setSelectedRowDetails(null);
        }}
      ></div>
      <div className={`details-slider-panel ${detailsModal ? "open" : ""}`}>
        <div className="details-slider-content">
          <div className="details-slider-header">
            <h5 style={{ color: "white", margin: 0 }}>
              <i className="fa fa-globe mr-2"></i>
              Dark Web Details
              {selectedRowDetails?.title && (
                <span className="ml-2" style={{ fontSize: "0.85em", opacity: 0.9, color: "white" }}>
                  - {selectedRowDetails.title}
                </span>
              )}
            </h5>
            <button
              type="button"
              className="details-slider-close"
              onClick={() => {
                setDetailsModal(false);
                setSelectedRowDetails(null);
              }}
              aria-label="Close"
            >
              <i className="fa fa-times"></i>
            </button>
          </div>
          <div className="details-slider-body">
            {selectedRowDetails && (
              <>
                {/* URL Information Section */}
                {selectedRowDetails?.thread_link && (
                  <div className="details-section">
                    <div className="details-section-title">
                      <i className="fa fa-link"></i>
                      Thread Link
                    </div>
                    <div className="details-info-item">
                      <span className="details-info-label">URL:</span>
                      <span className="details-info-value" style={{ wordBreak: "break-all" }}>
                        {selectedRowDetails.thread_link}
                      </span>
                    </div>
                  </div>
                )}

                {/* Screenshot Section */}
                {(selectedRowDetails?.fixed_screenshot_path || selectedRowDetails?.fullpage_screenshot_url) && (
                  <div className="details-section">
                    <div className="details-section-title">
                      <i className="fa fa-image"></i>
                      Screenshot
                    </div>
                    <div style={{ 
                      display: "flex", 
                      justifyContent: "center", 
                      alignItems: "center",
                      padding: "15px",
                      backgroundColor: "#f8f9fa",
                      borderRadius: "4px",
                      minHeight: "200px"
                    }}>
                      {screenshotError ? (
                        <div style={{ textAlign: "center", padding: "20px", color: "#6c757d" }}>
                          <i className="fa fa-exclamation-triangle" style={{ fontSize: "24px", marginBottom: "10px", display: "block", color: "#ffc107" }}></i>
                          <p style={{ marginBottom: "10px" }}>Unable to load screenshot</p>
                          <a 
                            href={selectedRowDetails.fullpage_screenshot_url || selectedRowDetails.fixed_screenshot_path} 
                            target="_blank" 
                            rel="noopener noreferrer" 
                            style={{ color: "#453acd", textDecoration: "underline" }}
                          >
                            <i className="fa fa-external-link mr-1"></i>
                            Open screenshot URL
                          </a>
                        </div>
                      ) : (
                        <img
                          src={screenshotUrl || selectedRowDetails.fullpage_screenshot_url || selectedRowDetails.fixed_screenshot_path}
                          alt="Screenshot"
                          className="image-clickable"
                          style={{
                            maxWidth: "100%",
                            maxHeight: "500px",
                            borderRadius: "4px",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                            cursor: "pointer",
                            objectFit: "contain"
                          }}
                          onClick={() => {
                            setImageModalSrc(screenshotUrl || selectedRowDetails.fullpage_screenshot_url || selectedRowDetails.fixed_screenshot_path);
                            setImageModalOpen(true);
                          }}
                          onError={() => {
                            setScreenshotError(true);
                          }}
                          onLoad={() => {
                            setScreenshotError(false);
                          }}
                          title="Click to view full size"
                        />
                      )}
                    </div>
                    <div style={{ marginTop: "10px", textAlign: "center" }}>
                      <a 
                        href={selectedRowDetails.fullpage_screenshot_url || selectedRowDetails.fixed_screenshot_path} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        style={{ 
                          color: "#453acd", 
                          textDecoration: "none",
                          fontSize: "0.85rem"
                        }}
                      >
                        <i className="fa fa-external-link mr-1"></i>
                        Open screenshot in new tab
                      </a>
                    </div>
                  </div>
                )}

                {/* Description Section */}
                {selectedRowDetails?.description && (
                  <div className="details-section">
                    <div className="details-section-title">
                      <i className="fa fa-file-text"></i>
                      Description
                    </div>
                    <div style={{ 
                      whiteSpace: "pre-wrap",
                      wordBreak: "break-word",
                      overflowWrap: "break-word",
                      padding: "12px",
                      backgroundColor: "#f8f9fa",
                      borderRadius: "4px",
                      border: "1px solid #dee2e6",
                      fontFamily: "monospace",
                      fontSize: "0.9rem",
                      lineHeight: "1.6",
                      maxHeight: "400px",
                      overflowY: "auto"
                    }}>
                      {selectedRowDetails.description}
                    </div>
                  </div>
                )}

                {/* OCR Content Section */}
                {selectedRowDetails?.ocr_content && (
                  <div className="details-section">
                    <div className="details-section-title">
                      <i className="fa fa-eye"></i>
                      OCR Content
                    </div>
                    <div style={{ 
                      whiteSpace: "pre-wrap",
                      wordBreak: "break-word",
                      overflowWrap: "break-word",
                      padding: "12px",
                      backgroundColor: "#f8f9fa",
                      borderRadius: "4px",
                      border: "1px solid #dee2e6",
                      fontFamily: "monospace",
                      fontSize: "0.9rem",
                      lineHeight: "1.6",
                      maxHeight: "400px",
                      overflowY: "auto"
                    }}>
                      {selectedRowDetails.ocr_content}
                    </div>
                  </div>
                )}

                {/* Basic Information Section */}
                <div className="details-section">
                  <div className="details-section-title">
                    <i className="fa fa-info-circle"></i>
                    Basic Information
                  </div>
                  <div className="details-info-item">
                    <span className="details-info-label">Title:</span>
                    <span className="details-info-value">
                      {selectedRowDetails?.title || "N/A"}
                    </span>
                  </div>
                  <div className="details-info-item">
                    <span className="details-info-label">Author Name:</span>
                    <span className="details-info-value">
                      {selectedRowDetails?.author_name || "N/A"}
                    </span>
                  </div>
                  <div className="details-info-item">
                    <span className="details-info-label">Source:</span>
                    <span className="details-info-value">
                      {selectedRowDetails?.source || "N/A"}
                    </span>
                  </div>
                  <div className="details-info-item">
                    <span className="details-info-label">Date:</span>
                    <span className="details-info-value">
                      {selectedRowDetails?.date ? moment(selectedRowDetails.date, "DD-MM-YYYY hh:mm A").format("DD-MM-YYYY") : "N/A"}
                    </span>
                  </div>
                  {selectedRowDetails?.createdAt && (
                    <div className="details-info-item">
                      <span className="details-info-label">Created At:</span>
                      <span className="details-info-value">
                        {moment(selectedRowDetails.createdAt).format("DD-MM-YYYY HH:mm")}
                      </span>
                    </div>
                  )}
                  {selectedRowDetails?.updatedAt && (
                    <div className="details-info-item">
                      <span className="details-info-label">Updated At:</span>
                      <span className="details-info-value">
                        {moment(selectedRowDetails.updatedAt).format("DD-MM-YYYY HH:mm")}
                      </span>
                    </div>
                  )}
                  {selectedRowDetails?.actionNote && (
                    <div className="details-info-item" style={{ flexDirection: "column", alignItems: "flex-start" }}>
                      <span className="details-info-label" style={{ marginBottom: "8px" }}>Action Note:</span>
                      <span className="details-info-value" style={{ padding: "8px", backgroundColor: "#f8f9fa", borderRadius: "4px", width: "100%" }}>
                        {selectedRowDetails.actionNote}
                      </span>
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      {/* Image Modal for Full Screen View */}
      <ImageModal
        isOpen={imageModalOpen}
        onClose={() => setImageModalOpen(false)}
        imageSrc={imageModalSrc}
      />
    </div>
  );
};
export default DarkWeb;
